import React from 'react';
import { ReactTyped, Typed } from "react-typed";

function Hero() {
  return (
    <div className="text-white">
      <div className="mt-[10px] h-screen mt-[96px] w-full mx-auto flex flex-col text-center justify-center">
        <p className="text-[#00df9a] font-bold p-2">
          Growing With Data analytics
        </p>
        <h1 className="md:text-7xl sm:text-6xl text-4xl font-bold md:py-6">
          Grow with Data.
        </h1>
        <div className="flex justify-center items-center">
          <p className="md:text-5xl sm:text-4xl text-xl font-bold">
            Fast, flexible financing for
          </p>
          <ReactTyped
            className="md:text-5xl sm:text-4xl text-xl font-bold pl-2"
            strings={["Business", "Car Financing", "BTB", "BTC", "SASS"]}
            typeSpeed={140}
            backSpeed={80}
            loop={true}
          />
        </div>
        <p className="md:text-2xl text-xl font-bold text-gray-500 py-4">
          Monitor your busines to increase revenue generated by leveraging the
          financing for Business, BTB, Car financing and realtor Financing
        </p>
        <button
          className="bg-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto py-3"
          onClick={() =>
            (window.location.href =
              "https://baxiscore.com/oneplusone/account/login")
          }
        >
          Sign In
        </button>
      </div>
    </div>
  );
}
export default Hero;